import { render, staticRenderFns } from "./Manuscrit.vue?vue&type=template&id=6e39c913&scoped=true"
import script from "./Manuscrit.vue?vue&type=script&lang=js"
export * from "./Manuscrit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e39c913",
  null
  
)

export default component.exports